import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function () {
  // Step 1: Initialize dataLayer and gtag function
  const inlineScript = document.createElement('script');
  inlineScript.text = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-LTTKB8L6K8');
  `;
  document.head.insertBefore(inlineScript, document.head.firstChild);
  // Step 2: Load the external gtag.js script
  const externalScript = document.createElement('script');
  externalScript.async = true;
  externalScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-LTTKB8L6K8';
  document.head.insertBefore(externalScript, document.head.firstChild);
})();
render(<App data-id="element-418" />, document.getElementById('root'));